import Container from "components/MainDetails/Container";
import List from "./List";
import Details from "./Details";

const Job = () => {
  return (
    <Container>
      <List stateName="job" />
      <Details />
    </Container>
  );
};

export default Job;
